
import WithColorMixin from '@/mixins/WithColorMixin.vue';
import ValueSlider from './metrics/ValueSlider.vue';
import FlagLabel from './metrics/FlagLabel.vue';
import { useMetrics } from '@/store/metrics';
import { MetricType, NewMetric } from '@/types/metrics';
import { ScoreFilter } from '@/types/score';
import { mapActions } from 'pinia';
import { PropType } from 'vue';
import { defineComponent } from 'vue';
import { usePageStatus } from '@/store/pageStatus';


export type ScoreFilterWithColor = {
  filter: ScoreFilter,
  selected: boolean,
  range: boolean
}


const __default__ = defineComponent({
    name: 'MetricsSelector',
    props: {
        metrics: {
            type: Array as PropType<ScoreFilterWithColor[]>,
            default: () => { return [] }
        },
        width: String,
        allowNewMetric: {
            type: Boolean,
            default: false
        }
    },
    components: {
      "value-slider": ValueSlider,
      "flag-label": FlagLabel,
    },
    mixins: [WithColorMixin],
    data () {
        return {
          newMetric: {} as NewMetric,
          loading: false,
        }
    },
    mounted () {
      this.resetNewMetric()
    },
    computed: {
      metricsByCategory() {
        let map: {[key: string]: ScoreFilterWithColor[]} = {}
        this.metrics.forEach(
          (scoreFilterWithColor: ScoreFilterWithColor) => {
            const category = scoreFilterWithColor.filter.metric.category
            if (category in map)
              map[category].push(scoreFilterWithColor)
            else
              map[category] = [scoreFilterWithColor]
          }
        )
        return map
      }
    },
    methods: {
        ...mapActions(useMetrics, ["addMetric"]),
        ...mapActions(usePageStatus, ["setError"]),
        editMetric (metricWithValue: ScoreFilterWithColor) {
          if (!metricWithValue.selected) {
            this.selectMetric(metricWithValue)
          }
          else {
            metricWithValue.selected = false
            this.$emit("metricUnselected", metricWithValue)
          }
        },
        selectMetric (metricWithValue: ScoreFilterWithColor) {
          metricWithValue.selected = true
          this.$emit("metricSelected", metricWithValue)
        },
        toggleNewMetricType () {
          this.newMetric.type = this.newMetric.type === MetricType.value ? MetricType.flag : MetricType.value
        },
        async addNewMetric() {
          if (this.allowNewMetric) {
            this.loading = true
            await this.addMetric(this.newMetric).catch((error) => { console.log(error); this.setError("Unable to add metric" + error.message); }).finally(() => { this.loading = false })

            this.resetNewMetric()
          }
        },
        resetNewMetric () {
          this.newMetric = {
            name: "New Metric",
            type: MetricType.value,
            category: "other",
          }
        },
        clickOutside() {
          this.$emit("clickOutside")
        }
    }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "95f2009e": (_ctx.width),
  "68766df8": (_ctx.darkColor),
  "269970e2": (_ctx.lightColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__